import { OverviewItem } from './OverviewItem';

interface OverviewThreatItemProps {
  spamScore: number;
  sectionId?: string;
}

export const OverviewThreatItem = ({
  spamScore,
  sectionId = 'nuisance-caller-section',
}: OverviewThreatItemProps) => {
  const isThreat = spamScore >= 10;
  const label = isThreat ? 'Threat detected' : 'No threat detected';
  const buttonLabel = ' View threat detection';
  const iconName = 'CheckRounded';
  const containerProps = {
    containerProps: { 'data-cy': 'overview-threat-item' },
  };
  return (
    <OverviewItem
      label={label}
      iconName={iconName}
      buttonLabel={buttonLabel}
      section={sectionId}
      otherProps={containerProps}
    />
  );
};
